import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTicketChats } from 'services/smsConversations';

interface IParams {
  crmId: number;
  ticketId: string;
}

export const ThunkGetTicketChats = createAsyncThunk(
  'pod/getTicketChats',
  ({ crmId, ticketId }: IParams) => getTicketChats(crmId, ticketId).then(r => r.data),
);
